import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Accueil from "./pages/Accueil"
import Propos from "./pages/Propos"
import Services from "./pages/Services"
import Contact from "./pages/Contact"
import Projets from "./pages/projets";
// import Temoignages from "./pages/Temoignages";
import Technologies from "./pages/Technologies";
import PageErreur from "./pages/PageErreur";
import ErrorBoundary from "./components/ErrorBoundary";

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Navigate to="/Accueil" replace />} />
          <Route path="/Accueil" element={<Accueil />} />
          <Route path="/Propos" element={<Propos />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Projets" element={<Projets />} />
          <Route path="/Contact" element={<Contact />} />
          {/* <Route path="/Temoignages" element={<Temoignages />} /> */}
          <Route path="/Technologies" element={<Technologies />} />
          {/* <Route path="/PageErreur" element={<PageErreur />} /> */}

          {/* Wildcard route for all non-defined paths */}
          <Route path="*" element={<PageErreur />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
